module.exports = BMap;


//////////////////
// WEBPACK FOOTER
// external "BMap"
// module id = jkKj
// module chunks = 21